import { GlobalState } from '../types.global';
import { Experiment, FeatureFlags } from '../features/user/slice/types';
import { INITIAL_STATE } from '../features/user/slice/shared';

export const selectExperiment = ({ user }: GlobalState): Experiment =>
  user.experiment.value || INITIAL_STATE.experiment.value;

export const selectFeatureFlags = (state: GlobalState): FeatureFlags => {
  try {
    return selectExperiment(state).scenario.featureFlags;
  } catch (e) {
    console.error('selectFeatureFlags', e);
    return INITIAL_STATE.experiment.value.scenario.featureFlags;
  }
};

export const selectIsUserRegular = ({ user, friends }: GlobalState): boolean => {
  if (process.env.NODE_ENV === 'development') return true;
  if (user.isDev) return true;
  if (user.activityCounter >= 4 && user.ntpVisitCounter > 30) return true;
  if (user.installSource) return true;

  const whitelist = ['c8wjYyWd', 'UhfKt-xa'];
  return !!(friends?.friends?.list || []).find(({ id }) => whitelist.includes(id));
};

export const selectUiMode = ({ ui }: GlobalState): string => ui.mode;
